import { type JSONData } from "../../base_classes/dto.d";
import { PortalEventStatsDto } from "./dto.gen";
import { type IPortalEventStats } from "./entity.d";
import PortalEventStatsParsers from "./parsers";
import PortalEventStatsValidators from "./custom_validators";

export class PortalEventStats
  extends PortalEventStatsDto
  implements IPortalEventStats
{
  constructor(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        },
    data?: JSONData,
  ) {
    super(data, PortalEventStatsParsers, PortalEventStatsValidators);

    if (data !== undefined) {
      // Set data
      this.set(data);
    }

    this.buildPathObject(pathVars);
  }
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  public async get(
    pathVars?:
      | string
      | string[]
      | {
          id?: string;
        }
      | undefined,
  ): Promise<PortalEventStats> {
    return (await super.get(pathVars)) as PortalEventStats;
  }

  /// ///////////////////////////////////////
  /// /////////// STATIC METHODS ////////////
  /// ///////////////////////////////////////

  static override FromJSON(data?: JSONData): PortalEventStats {
    return new PortalEventStats(undefined, data);
  }

  static override FromJSONArray(data: JSONData[]): PortalEventStats[] {
    return data.map((item) => PortalEventStats.FromJSON(item));
  }

  static FromDto(dto: PortalEventStatsDto): PortalEventStats {
    return new PortalEventStats(undefined, dto.toJSON());
  }
}
